import { useState } from 'react'
import TriviaJuego from './TriviaJuego'
import AhorcadoJuego from './AhorcadoJuego'
import VerdaderoFalsoJuego from './VerdaderoFalsoJuego'
import MemoriaJuego from './MemoriaJuego'
import OrdenaFraseJuego from './OrdenaFraseJuego'
import ConjugacionJuego from './ConjugacionJuego'

const JUEGOS = [
  {
    id: 'trivia', emoji: '🧠', color: '#8B5CF6', dificultad: 'Medio',
    titulo: 'Trivia', listo: true,
    descripcion: 'Pon a prueba tu vocabulario, gramática, expresiones y cultura en inglés.'
  },
  {
    id: 'ahorcado', emoji: '🎯', color: '#22C55E', dificultad: 'Fácil',
    titulo: 'Ahorcado', listo: true,
    descripcion: 'Adivina la palabra en inglés antes de quedarte sin intentos.'
  },
  {
    id: 'memoria', emoji: '🃏', color: '#3B82F6', dificultad: 'Medio',
    titulo: 'Memoria de Palabras', listo: true,
    descripcion: 'Encuentra los pares de palabras en inglés y español.'
  },
  {
    id: 'ordena', emoji: '📝', color: '#F59E0B', dificultad: 'Medio',
    titulo: 'Ordena la Frase', listo: true,
    descripcion: 'Organiza las palabras para formar una oración correcta en inglés.'
  },
  {
    id: 'verdadero_falso', emoji: '⚖️', color: '#059669', dificultad: 'Fácil',
    titulo: 'Verdadero o Falso', listo: true,
    descripcion: 'Responde rápido: ¿es cierto o falso sobre inglés?'
  },
  {
    id: 'conjugacion', emoji: '⚡', color: '#EF4444', dificultad: 'Difícil',
    titulo: 'Conjugación Rápida', listo: true,
    descripcion: 'Conjuga verbos en inglés contra el reloj.'
  }
]

const COLOR_DIFICULTAD = {
  'Fácil': { fondo: '#DCFCE7', texto: '#166534' },
  'Medio': { fondo: '#FEF3C7', texto: '#92400E' },
  'Difícil': { fondo: '#FEE2E2', texto: '#B91C1C' }
}

/* Vestibulo de "EduNova Juegos": una cuadricula de tarjetas, una
   por cada mini-juego. Los juegos ya construidos son clickeables
   y se abren dentro de esta misma pagina; los que faltan se ven
   deshabilitados con un aviso de "Proximamente". */
export default function JuegosHub({ usuario, onCambio }) {
  const [juegoActivo, setJuegoActivo] = useState(null)

  if (juegoActivo === 'trivia') {
    return (
      <div>
        <button onClick={() => setJuegoActivo(null)}
          style={{ background: 'none', border: 'none', color: 'var(--azul)', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer', padding: 0, marginBottom: 16 }}>
          ← Volver a juegos
        </button>
        <TriviaJuego usuario={usuario} onCambio={onCambio} />
      </div>
    )
  }

  if (juegoActivo === 'ahorcado') {
    return (
      <div>
        <button onClick={() => setJuegoActivo(null)}
          style={{ background: 'none', border: 'none', color: 'var(--azul)', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer', padding: 0, marginBottom: 16 }}>
          ← Volver a juegos
        </button>
        <AhorcadoJuego usuario={usuario} onCambio={onCambio} />
      </div>
    )
  }

  if (juegoActivo === 'verdadero_falso') {
    return (
      <div>
        <button onClick={() => setJuegoActivo(null)}
          style={{ background: 'none', border: 'none', color: 'var(--azul)', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer', padding: 0, marginBottom: 16 }}>
          ← Volver a juegos
        </button>
        <VerdaderoFalsoJuego usuario={usuario} onCambio={onCambio} />
      </div>
    )
  }

  if (juegoActivo === 'memoria') {
    return (
      <div>
        <button onClick={() => setJuegoActivo(null)}
          style={{ background: 'none', border: 'none', color: 'var(--azul)', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer', padding: 0, marginBottom: 16 }}>
          ← Volver a juegos
        </button>
        <MemoriaJuego usuario={usuario} onCambio={onCambio} />
      </div>
    )
  }

  if (juegoActivo === 'ordena') {
    return (
      <div>
        <button onClick={() => setJuegoActivo(null)}
          style={{ background: 'none', border: 'none', color: 'var(--azul)', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer', padding: 0, marginBottom: 16 }}>
          ← Volver a juegos
        </button>
        <OrdenaFraseJuego usuario={usuario} onCambio={onCambio} />
      </div>
    )
  }

  if (juegoActivo === 'conjugacion') {
    return (
      <div>
        <button onClick={() => setJuegoActivo(null)}
          style={{ background: 'none', border: 'none', color: 'var(--azul)', fontFamily: 'inherit', fontSize: 13, fontWeight: 700, cursor: 'pointer', padding: 0, marginBottom: 16 }}>
          ← Volver a juegos
        </button>
        <ConjugacionJuego usuario={usuario} onCambio={onCambio} />
      </div>
    )
  }

  return (
    <div style={{ animation: 'fadeIn .3s ease both', maxWidth: 920 }}>
      <div style={{ background: 'linear-gradient(135deg,var(--azul-oscuro),var(--azul))', borderRadius: 18, padding: '28px 30px', color: '#fff', marginBottom: 26 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <span style={{ fontSize: 40 }}>🎮</span>
          <div>
            <h1 style={{ fontSize: 24, fontWeight: 800 }}>EduNova Juegos</h1>
            <p style={{ fontSize: 14, opacity: .85, marginTop: 4 }}>
              Aprende inglés jugando. Cada juego refuerza tu vocabulario y gramática.
            </p>
          </div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))', gap: 16 }}>
        {JUEGOS.map(j => {
          const dif = COLOR_DIFICULTAD[j.dificultad]
          return (
            <div key={j.id}
              onClick={() => j.listo && setJuegoActivo(j.id)}
              style={{
                background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 16, overflow: 'hidden',
                cursor: j.listo ? 'pointer' : 'default', opacity: j.listo ? 1 : 0.65,
                transition: 'all .18s ease'
              }}
              onMouseOver={e => { if (j.listo) { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(27,58,140,.10)' } }}
              onMouseOut={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = 'none' }}>
              <div style={{ height: 5, background: j.color }} />
              <div style={{ padding: 20 }}>
                <div style={{ fontSize: 34, marginBottom: 12 }}>{j.emoji}</div>
                <h3 style={{ fontSize: 16, fontWeight: 800, marginBottom: 6 }}>{j.titulo}</h3>
                <p style={{ fontSize: 12.5, color: 'var(--gris-texto)', lineHeight: 1.4, marginBottom: 16, minHeight: 34 }}>
                  {j.descripcion}
                </p>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ background: dif.fondo, color: dif.texto, fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 999 }}>
                    {j.dificultad}
                  </span>
                  {j.listo ? (
                    <span style={{ color: j.color, fontSize: 13, fontWeight: 700 }}>Jugar →</span>
                  ) : (
                    <span style={{ color: 'var(--gris-texto)', fontSize: 11, fontWeight: 700 }}>Próximamente</span>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
